import { styled } from "@material-ui/core";
import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
// import {ReactComponent  as DeleteIcon} from 'assets/icons/ban.svg'

export const MainBody = styled('div')(({ theme }) => ({
    position: 'fixed',
    top: '0px',
    left: '0px',
    width: '100%',
    height: '100%',
    backgroundColor: '#1a1a1a',
    zIndex: 1200,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
}))

export const MenuCont = styled('div')(({ theme }) => ({
    position: 'fixed',
    top: '30px',
    right: '0px',
    width: '0px',
    height: '0px',
    backgroundColor: 'transparent',
    zIndex: 1200,
    display: 'flex',
    justifyContent: 'end',
    alignItems: 'center'
}))

export const LogoCont = styled('div')(({ theme }) => ({
    width: 'auto',
    height: '50px',
    position: 'absolute',
    top: '20px',
    left: '20px'
}))

export const CloseIconCont = styled('div')(({ theme }) => ({
    width: '30px',
    height: '30px',
    position: 'absolute',
    top: '20px',
    right: '20px',
    cursor: 'pointer'
}))

export const StoryCont = styled('div')(({ theme }) => ({
    position: 'relative',
    top: '-10px',
    width: '25vw',
    height: '90vh',
    minWidth: '300px',
    maxWidth: '500px',
    backgroundColor: '#fefefe',
    borderRadius: '10px',
    boxShadow: theme.shadows[10],
    overflow: 'hidden',
    '& .card-dragging': {
        zIndex: 10,
    },
    '& > div': {
        position: 'absolute',
        // top: '0px',
        // left: '0px',
        // zIndex: 0,
    },
    [theme.breakpoints.down('xs')]: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        top: '0px',
        left: '0px',
    }
}))

export const Video = styled('video')(({ theme }) => ({
    position: 'absolute',
    top: '0px',
    left: '0px',
    height: '100%',
    width: '100%',
    objectFit: 'cover',
}))

export const Img = styled('img')(({ theme }) => ({
    position: 'absolute',
    top: '0px',
    left: '0px',
    height: '100%',
    width: '100%',
    objectFit: 'cover',
}))

export const ProgressBarCont = styled('div')(({ theme }) => ({
    width: 'calc(100% - 20px)',
    height: 'max-content',
    position: 'absolute',
    top: '10px',
    left: '0px',
    display: 'flex',
    justifyContent: 'stretch',
    alignItems: 'center',
    gap: '5px',
    zIndex: 10,
    padding: '10px'
}))

export const Arrow = styled('img')(() => ({
    borderRadius: '50%',
    backgroundColor: 'rgb(41 39 57 / 80%)',
    position: 'absolute',
    top: '50%',
    padding: '7px',
    width: '12px',
    height: '12px',
    cursor: 'pointer'
}))

export const LeftArrow = styled(Arrow)(() => ({
    left: '5px',
    transform: 'rotate(180deg)'
}))

export const RightArrow = styled(Arrow)(() => ({
    right: '5px',
}))

export const UserDetailCont = styled(Box)(() => ({
    position: 'absolute',
    top: '25px',
    left: '0px',
    display: 'flex',
    alignItems: 'center',
    zIndex: 10,
    width: 'calc(100% - 20px)',
    height: 'max-content',
    gap: '5px',
    padding: '10px',
    '& img': {
        width: '45px',
        height: '45px'
    }
}))


export const UsernameText = styled(Typography)(() => ({
    fontWeight: 'lighter',
    color: '#fff'
}))


export const CustomLink = styled(Link)(() => ({
    position: 'absolute',
    top: '100px',
    left: '20px',
    // fontWeight: 'lighter',
    color: '#fff',
    textDecoration: 'none'
}))



export const Overlay = styled('div')(() => ({
    position: 'absolute',
    top: '0px',
    left: '0px',
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, .1)',
    zIndex: 2000
}))


export const ToggleBackgroundButton = styled('div')(({theme}) => ({
    position: 'absolute',
    bottom: '10px !important',
    right: '10px !important',
    width: '30px',
    height: '30px',
    borderRadius: '50%',
    backgroundColor: 'rgba(0, 0, 0, 1)',
    cursor: 'pointer',
    boxShadow: theme.shadows[3],
    border: '3px solid #fff'
}))


export const DeleteButton = styled('img')(() => ({
    position: 'absolute',
    bottom: '50px',
    left: '50%',
    width: '50px',
    height: '50px',
    padding: '20px',
    // filter: 'invert(1)',
    transform: 'translate(-50%, -50%)',
    backgroundColor: 'rgba(0, 0, 0, .3)',
    borderRadius: '50%',
    zIndex: 2000,
    '&:hover': {
        filter: 'invert(0)',
        backgroundColor: 'rgba(255, 100, 100, 1)',
    },
    '&.hover': {
        filter: 'invert(0)',
        backgroundColor: 'rgba(255, 100, 100, 1)',
    },
    userSelect: 'none',
}))

export const MentionText = styled('p')(({ theme }) => ({
    width: 'fit-content',
    height: '100%',
    padding: '0px 10px',
    margin: '0px',
    color: 'yellow',
    wordBreak: 'break-all',
    fontSize: '1.8rem',
}))

export const LinkText = styled('a')(({ theme }) => ({
    width: 'fit-content',
    height: '100%',
    wordBreak: 'break-word',
    padding: '0px 10px',
    margin: '0px',
    color: '#0089ff',
    transform: 'translate(-50%, 0%)',
    fontSize: '1.8rem',
}))

export const ImageCard = styled('img')(({ theme }) => ({
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    borderRadius: '10px',
    // boxShadow: theme.shadows[5]
}))


export const BottomButtonsCont = styled('div')(({ theme }) => ({
    position: 'absolute',
    bottom: '0px',
    left: '50%',
    width: '25vw',
    maxWidth: '500px',
    minWidth: '300px',
    marginBottom: '5px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    transform: 'translateX(-50%)',
    [theme.breakpoints.down('xs')]: {
        width: '95vw',
    }
}))


export const TestDiv = styled('div')(({ theme }) => ({
    position: 'absolute',
    bottom: '0px',
    left: '0px',
    width: '100px',
    height: '100px',
    background: '#fff'
}))


